module.exports = __webpack_public_path__ + "media/theme/icon__dmm-6836c852.svg";